const commomRouteProps = {
  to: "/",
  exact: true,
  activeClassName: "link-exact-active",
};

export const routes = [
  {
    ...commomRouteProps,
    to: "/about",
    hash: "#about",
    name: "About",
  },
  // {
  //   ...commomRouteProps,
  //   to:
  //   'https://www.notion.so/Example-Blog-Posts-0e220095e10c4f1d8e35da50a0e74ebd',
  //   hash: '#example-posts',
  //   name: 'Example Posts',
  // },
  {
    ...commomRouteProps,
    to: "/testimonials",
    hash: "#testimonials",
    name: "Testimonials",
  },
  {
    ...commomRouteProps,
    to: "/faq",
    hash: "#faq",
    name: "FAQ",
  },
  // {
  //   ...commomRouteProps,
  //   to: '/blog',
  //   name: 'Blog',
  // },
];
